<template>
  <b-col md="6" offset="3" class="login-container">
    <div class="logo-container full-width">
      <img src="static/img/basic/boom_logo.png" alt="">
    </div>
    <amplify-authenticator class="authenticator" v-bind:authConfig="authConfig"/>
  </b-col>
</template>

<script>
  import { I18n } from 'aws-amplify'

  I18n.setLanguage('en');
  I18n.putVocabularies({
    en: {
      'Username': 'Email',
      'Enter your username': 'Enter your email'
    }
  });
  export default {
    name: "SignIn",
    data() {
      return {
        authConfig: {
          signUpConfig: {
            hiddenDefaults: ['phone_number', 'username', 'email'],
            signUpFields: [
              {
                label: "First Name",
                key: "given_name",
                required: true,
                type: "string",
                displayOrder: 0
              },
              {
                label: "Last Name",
                key: "family_name",
                required: true,
                type: "string",
                displayOrder: 1
              },
              {
                label: 'Confirm Email',
                key: 'username',
                required: true,
                type: 'email',
                displayOrder: 3
              },
              {
                label: 'Password',
                key: 'password',
                required: true,
                type: 'password',
                displayOrder: 4
              },
              {
                label: "Business Name",
                key: "business_name",
                required: false,
                type: "string",
                displayOrder: 5,
                custom: true,
              },
              {
                label: 'Phone Number',
                key: 'phone_number',
                required: true,
                displayOrder: 6,
                type: 'string'
              },
            ]
          }
        }
      }
    }
  }
</script>


<!-- <script>
  import { I18n }  from 'aws-amplify'

  I18n.setLanguage('en');
  I18n.putVocabularies({
    en: {
      'Username': 'Email',
      'Enter your Username': 'Enter your email'
    }
  });

  export default {
    name: "SignIn",
    data() {
      return {
        authConfig: {
          signUpConfig: {
            hiddenDefaults: ['phone_number', 'username', 'email'],
            signUpFields: [
              
            ]
          }
        }
      }
    }
  }
</script>
 -->
<style scoped>
  .authenticator >>> .error {
    margin-top: 25px;
    background-color: transparent;
    color: red;
  }

  .authenticator >>> .Form__formSection___3tqxz {
    background-color: transparent;
    box-shadow: none;
    -webkit-box-shadow: none;
  }

  .authenticator >>> .Section__sectionHeader___13iO4 {
    display: none;
  }

  .authenticator >>> .Input__inputLabel___nQolz {
    display: none;
  }

  .authenticator >>> .Section__sectionFooter___1QlDn {
    display: block;
  }

  .authenticator >>> .Section__sectionFooterSecondaryContent___3cjOa {
    position: relative;
    top: 10px;
    float: right;
  }

  .authenticator >>> .Button__button___1FrBC {
    width: 100%;
    min-width: 100%;
    background-color: #5cb85c;
    border-radius: 8px;
  }

  .login-container {
    background: #fff;
    margin-top: 64px;
    border-radius: 16px;
  }

  .logo-container {
    padding-top: 36px;
    padding-bottom: 16px;
    text-align: center;
    display: block;
  }

  .logo-container img {
    width: 200px;
  }

  .full-width {
    width: 100%;
  }

  a {
    text-decoration-color: #0275d8;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/SignIn.vue